/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Customer_Group_Already_In_GroupInputs */

const vi_customer_group_already_in_group = /** @type {(inputs: Customer_Group_Already_In_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách hàng đang thuộc nhóm "${i?.group}", sẽ được chuyển sang nhóm này`)
};

/**

* @param {Customer_Group_Already_In_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_already_in_group = /** @type {((inputs: Customer_Group_Already_In_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_Already_In_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_already_in_group(inputs)
});